module.exports = __webpack_public_path__ + "img/IngredientsChecked.6aa51f47.svg";